<script>
import { random_string } from "../../libraries/random_string";


export let id = "modal-"+random_string(6);
export let classes = "";
export let classesContent = "";
export let classesHeader = "";
export let triggerClass = "";
export let styles = "";
export let closeOnClickOverlay = true;
export let onClose = function(){};
export let onOpen = function(){};
export let active = false;


let roleOverlay = "";
let modal = null;
let OverlayClick = ()=>{}
if(closeOnClickOverlay === true){
    roleOverlay = "data-micromodal-close";
    OverlayClick = ()=>{
        active = false;
    }
}



function activeModal(){
    active = true;
}
function deactivateModal(){
    active = false;
}
classes += " is-open"; 

$: if(modal !== null){
    let container = modal.querySelector(".modal__container");
    container.classList.add("animate__animated", "animate__fadeInUp", "faster", "animated");
    document.body.appendChild(modal);
}

</script>
<style>
.modal__container{
    overflow-y:auto;padding-bottom:60px;
}
/**************************\
  Basic Modal Styles
\**************************/

.modal__overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgb(80 78 96 / 45%);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 50;
}

.modal__container {
  background-color: #fff;
  padding: 30px;
  max-width: 500px;
  max-height: 100vh;
  border-radius: 4px;
  overflow-y: auto;
  box-sizing: border-box;
}

.modal__container.padding-0 {
  padding: 0;
}

.modal__header {
  display: flex;
  justify-content: end;
  align-items: center;
}

.modal__header.is-absolute-right {
  position: absolute !important;
  right: 1rem;
  top: 1rem;
}

.modal__title {
  margin-top: 0;
  margin-bottom: 0;
  font-weight: 600;
  font-size: 1.25rem;
  line-height: 1.25;
  color: #00449e;
  box-sizing: border-box;
}

.modal__close {
  background: transparent;
  border: 0;
}

.modal__header .modal__close:before { content: "\2715"; }

.modal__content {
  margin-top: 2rem;
  margin-bottom: 2rem;
  line-height: 1.5;
  color: rgba(0,0,0,.8);
}
.modal__content.margin-0{
  margin-top: 0;
  margin-bottom: 0;
}

.modal__btn {
  font-size: .875rem;
  padding-left: 1rem;
  padding-right: 1rem;
  padding-top: .5rem;
  padding-bottom: .5rem;
  background-color: #e6e6e6;
  color: rgba(0,0,0,.8);
  border-radius: .25rem;
  border-style: none;
  border-width: 0;
  cursor: pointer;
  -webkit-appearance: button;
  text-transform: none;
  overflow: visible;
  line-height: 1.15;
  margin: 0;
  will-change: transform;
  -moz-osx-font-smoothing: grayscale;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  -webkit-transform: translateZ(0);
  transform: translateZ(0);
  transition: -webkit-transform .25s ease-out;
  transition: transform .25s ease-out;
  transition: transform .25s ease-out,-webkit-transform .25s ease-out;
}

.modal__btn:focus, .modal__btn:hover {
  -webkit-transform: scale(1.05);
  transform: scale(1.05);
}

.modal__btn-primary {
  background-color: #00449e;
  color: #fff;
}



/**************************\
  Demo Animation Style
\**************************/
.micromodal-slide {
  display: none;
}

.micromodal-slide.is-open {
  display: block;
}

.micromodal-slide .modal__container,
.micromodal-slide .modal__overlay {
  will-change: transform;
}
.modal__container{
    max-width: 900px;
    min-width: 320px;
    width: 100%;
    min-height: 50px;
    max-height: calc(100vh - 3.25rem);
    border-radius: 20px;
    position: relative;
    z-index: 10;
    animation: fadeInUp; /* referring directly to the animation's @keyframe declaration */
    animation-duration: 0.5s; /* don't forget to set a duration! */
}
.custom-modal [data-micromodal-close]{
    cursor: pointer;
}
a{
    width: 100%;
    height: 100%;
}
.overlay_trigger{
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: 5;
}
</style>
{#if active === true}
    <div class="custom-modal {classes} micromodal-slide" id="{id}" aria-hidden="true" bind:this={modal}>
        <section class="modal__overlay" tabindex="-1" data-trigger={roleOverlay} >
            <div class="overlay_trigger" on:click={OverlayClick}></div>
            <div style="{styles}" class="modal__container animate__animated animate__fadeInUp faster animated custom-scrollbar {classesContent}" role="dialog" aria-modal="true" aria-labelledby="{id}-title">
                <header class="modal__header {classesHeader}" style="position:relative;">
                    <slot name="title" {active}></slot>
                    <button class="modal__close" aria-label="Close modal" on:click="{deactivateModal}" data-micromodal-close on:click="{onClose}"></button>
                </header>
                <main class="modal__content {classesContent}" id="{id}-content">
                    <slot hide={deactivateModal} open={activeModal}></slot>
                    <slot name="content" {active}></slot>
                </main>
                <footer class="modal__footer" id="{id}-footer">
                    <slot name="footer" {active}></slot>
                </footer>
            </div>
        </section>
    </div>
{/if}
<a class="{triggerClass}" style="text-decoration: none;" href="# " on:click|preventDefault={activeModal} on:click|preventDefault={onOpen}>
    <slot name="trigger"></slot>
</a>


<!-- LAYOUT EXAMPLE


<SimpleModal id="modal_1" closeOnClickOverlay={true}>
    <div slot="title" let:active>
        Title
    </div>
    <div slot="content" let:active>
        Hello Content
    </div>
    <div slot="footer" let:active>
        Footer
    </div>
    <div slot="trigger" let:active>
        <button>
            Open
        </button>
    </div>
</SimpleModal>


-->